import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => (
  <div
    style={{
      maxWidth: 900,
      margin: '2rem auto',
      paddingTop: 'calc(env(safe-area-inset-top, 16px) + 80px)',
      fontFamily: 'Arial, sans-serif',
      paddingLeft: '16px',
      paddingRight: '16px',
    }}
  >
          <h1 style={{ color: '#e52e71' }}>Términos y Condiciones</h1>
          <div style={{ marginBottom: '2rem' }}>
            <h2>1. Información General</h2>
            <p>Estos Términos y Condiciones ("Términos") regulan el uso del servicio en línea (el "Servicio") disponible en <strong>fotopacasa.es</strong>. El Servicio es operado por FIEFIA S.L.("nosotros").</p>
            <ul>
              <li>El Servicio permite a los usuarios subir, procesar y comprar fotos digitales de carnet para documentos oficiales.</li>
              <li>Al utilizar el Servicio, aceptas estos Términos. Si no los aceptas, no puedes usar el Servicio.</li>
              <li>El Servicio está destinado a usuarios mayores de 16 años.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>2. Responsabilidades del Usuario</h2>
            <ul>
              <li>Eres responsable de verificar que la foto subida cumpla los requisitos del documento deseado.</li>
              <li>Debes usar el Servicio conforme a la ley y la normativa aplicable.</li>
              <li>El acceso al Servicio requiere un dispositivo con internet y un navegador web compatible.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>3. Servicio y Pago</h2>
            <ul>
              <li>Tras subir y confirmar tu foto, podrás comprar la foto procesada usando los métodos de pago disponibles.</li>
              <li>Todos los precios se muestran en euros e incluyen IVA cuando corresponda.</li>
              <li>El pago se gestiona a través de proveedores externos. Al pagar, aceptas sus términos y condiciones.</li>
              <li>Tras el pago exitoso, podrás descargar tu foto procesada.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>4. Política de Devoluciones y Reembolsos</h2>
            <p><strong>Derecho de Desistimiento:</strong></p>
            <ul>
              <li>Según la ley española de protección al consumidor, tienes derecho a desistir de tu compra en un plazo de 14 días naturales desde la fecha de compra, sin necesidad de justificación.</li>
              <li>Sin embargo, este derecho no se aplica a contenido digital si has consentido expresamente a la ejecución inmediata y reconocido que perderás tu derecho de desistimiento una vez que el servicio se haya prestado completamente.</li>
              <li>Para fotos digitales: Una vez que hayas descargado la foto procesada, el derecho de desistimiento queda renunciado ya que el servicio se ha prestado completamente.</li>
              <li>Para productos físicos: Puedes ejercer tu derecho de desistimiento dentro de 14 días naturales desde la recepción del producto, siempre que el producto se devuelva en su estado original.</li>
            </ul>
            <p><strong>Condiciones de Reembolso:</strong></p>
            <ul>
              <li>Si tu foto procesada es rechazada por una autoridad oficial (DNI, Oficina de Pasaportes, etc.) y proporcionas prueba oficial del rechazo, puedes solicitar un reembolso completo.</li>
              <li>Las solicitudes de reembolso deben presentarse dentro de los 30 días posteriores a la compra y deben incluir prueba del rechazo oficial.</li>
              <li>Los reembolsos se procesarán usando el mismo método de pago utilizado en la compra dentro de 14 días hábiles desde la aprobación.</li>
              <li>Para productos físicos, el producto debe devolverse en su estado original y embalaje. Los costos de envío de devolución corren a cargo del cliente, a menos que el producto esté defectuoso o sea incorrecto.</li>
              <li>En caso de productos físicos defectuosos o incorrectos, cubriremos los costos de envío de devolución y proporcionaremos un reembolso completo o reemplazo.</li>
            </ul>
            <p><strong>Cómo Solicitar un Reembolso:</strong></p>
            <ul>
              <li>Contáctanos en <a href="mailto:ayuda.fotopacasa@fiefia.es">ayuda.fotopacasa@fiefia.es</a> con tu número de pedido y motivo de la solicitud de reembolso.</li>
              <li>Para reembolsos por rechazo oficial, incluye documentación oficial como prueba.</li>
              <li>Para devoluciones de productos físicos, incluye fotos del estado del producto.</li>
              <li>Nuestro objetivo es responder a las solicitudes de reembolso en un plazo de 14 días hábiles.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>5. Política de Envío</h2>
            <p><strong>Entrega de Productos Físicos:</strong></p>
            <ul>
              <li>Los productos físicos de fotos (opción de €4.99) se enviarán a la dirección de entrega proporcionada durante el proceso de compra.</li>
              <li>Tiempos de entrega: El envío estándar dentro de España tarda entre 3 y 5 días hábiles desde la fecha de confirmación del pedido.</li>
              <li>El envío internacional está disponible y típicamente tarda entre 7 y 15 días hábiles, dependiendo del país de destino.</li>
              <li>Los costos de envío están incluidos en el precio del producto físico para entregas dentro de España. El envío internacional puede incurrir en cargos adicionales.</li>
              <li>Recibirás un email de confirmación de envío con información de seguimiento una vez que tu pedido haya sido despachado.</li>
            </ul>
            <p><strong>Información de Entrega:</strong></p>
            <ul>
              <li>Es tu responsabilidad proporcionar una dirección de entrega correcta y completa. No nos hacemos responsables de retrasos o no entrega debido a información de dirección incorrecta.</li>
              <li>Si la entrega falla debido a una dirección incorrecta o si el destinatario no está disponible, pueden aplicarse costos de envío adicionales para la nueva entrega.</li>
              <li>Nos reservamos el derecho de cancelar pedidos si la dirección de entrega está en un área donde no podemos proporcionar servicios de entrega confiables.</li>
              <li>Los productos se envían usando servicios de mensajería confiables. Puede requerirse firma al recibir para pedidos de alto valor.</li>
            </ul>
            <p><strong>Problemas de Envío:</strong></p>
            <ul>
              <li>Si no recibes tu pedido dentro del tiempo esperado, por favor contáctanos en <a href="mailto:ayuda.fotopacasa@fiefia.es">ayuda.fotopacasa@fiefia.es</a> con tu número de pedido.</li>
              <li>Investigaremos el problema y proporcionaremos actualizaciones dentro de 3-5 días hábiles.</li>
              <li>Si el producto se pierde durante el envío, enviaremos un reemplazo sin costo adicional o proporcionaremos un reembolso completo, a tu elección.</li>
              <li>Si el producto llega dañado, por favor contáctanos inmediatamente con fotos del daño. Organizaremos un reemplazo o reembolso completo.</li>
            </ul>
            <p><strong>Entrega de Productos Digitales:</strong></p>
            <ul>
              <li>Las fotos digitales (opción de €0.99) se entregan inmediatamente por email o enlace de descarga después del pago exitoso.</li>
              <li>Los productos digitales se proporcionan de forma instantánea y no requieren envío físico.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>6. Reclamaciones</h2>
            <ul>
              <li>Para cualquier reclamación, consulta o solicitud de soporte, por favor contáctanos en <a href="mailto:ayuda.fotopacasa@fiefia.es">ayuda.fotopacasa@fiefia.es</a>.</li>
              <li>Nuestro objetivo es responder a todas las consultas en un plazo de 14 días hábiles.</li>
              <li>Por favor incluye tu número de pedido y descripción detallada del problema en tu reclamación.</li>
              <li>Según las regulaciones de protección al consumidor de la UE, si no estás satisfecho con nuestra respuesta, puedes contactar el Centro Europeo del Consumidor en España o usar la plataforma de Resolución de Disputas Online en <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>7. Privacidad</h2>
            <ul>
              <li>Tus datos personales se procesan conforme a nuestra <Link to="/privacy">Política de Privacidad</Link>.</li>
              <li>No recopilamos datos de menores de 16 años de forma consciente.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>8. Cambios en los Términos</h2>
            <ul>
              <li>Podemos actualizar estos Términos ocasionalmente. Los cambios se publicarán en esta página y entrarán en vigor 14 días después de su publicación.</li>
              <li>El uso continuado del Servicio tras los cambios implica la aceptación de los nuevos Términos.</li>
            </ul>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <h2>9. Disposiciones Finales</h2>
            <ul>
              <li>Estos Términos se rigen por la legislación española.</li>
              <li>Si alguna disposición resulta inválida, el resto de las disposiciones seguirán en vigor.</li>
            </ul>
          </div>
  </div>
);

export default Terms;